// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { I18nextProvider } from "react-i18next";
// import i18n from "./store/i18n";
// import Home from "./Components/Home";
// import Products from "./Components/Products";
// import Header from "./Components/Header";
// import Footer from "./Components/Footer";
// import WhyChooseUs from "./Components/WhyChooseUs";
// import AboutUs from "./Components/AboutUs";
// import ContactForm from "./Components/ContactForm";
// import Founders from "./Components/Founders";
// import Blogs from "./Components/Blogs";
// import Testimonials from "./Components/Testimonials"

// const App = () => {
//   const [language, setLanguage] = useState(i18n.language);

//   const changeLanguage = (lang) => {
//     i18n.changeLanguage(lang);
//     setLanguage(lang);
//   };

//   return (
//     <I18nextProvider i18n={i18n}>
//       <Router>
//         <Header changeLanguage={changeLanguage} />
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/about" element={<AboutUs />} />
//           <Route path="/products/:category" element={<Products />} />
//           <Route path="/footer" element={<Footer />} />
//           <Route path="/contact" element={<ContactForm />} />
//           <Route path="/founders" element={<Founders />} />
//           <Route path="/testimonials" element={<Testimonials />} />
//           <Route path="/blogs" element={<Blogs/>} />
//         </Routes>
//         <Footer />
//       </Router>
//     </I18nextProvider>
//   );
// };

// export default App;

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./store/i18n";
import Home from "./Components/Home";
import Products from "./Components/Products";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import AboutUs from "./Components/AboutUs";
import AboutUsTwo from "./Components/AboutUsTwo";

import ContactForm from "./Components/ContactForm";
import Founders from "./Components/Founders";
import Blogs from "./Components/Blogs";
import Testimonials from "./Components/Testimonials";
import WhyChooseUs from "./Components/WhyChooseUs";
import ScrollToTop from "./Components/ScrollToTop";

const App = () => {
  const [language, setLanguage] = useState(i18n.language);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
      <ScrollToTop /> {/* ✅ Correct placement */}
        <MainLayout changeLanguage={changeLanguage} />
      </Router>
    </I18nextProvider>
  );
};

const MainLayout = ({ changeLanguage }) => {
  const location = useLocation();

  // Sirf "/products" path par header aur footer hide karna hai
  const isProductsPage = location.pathname === "/products";

  return (
    <>
      {!isProductsPage && <Header changeLanguage={changeLanguage} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUsTwo />} />
        <Route path="/products" element={<Products />} /> {/* Products list page */}
        <Route path="/products/:category" element={<Products />} /> {/* Category-wise products */}
        <Route path="/contactus" element={<ContactForm />} />
        <Route path="/founders" element={<Founders />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/whyChooseUs" element={<WhyChooseUs/>} />
      </Routes>
      {!isProductsPage && <Footer />}
    </>
  );
};

export default App;
